(function () {
  'use strict';

  if (window.__toserofYorumlar) return;
  window.__toserofYorumlar = true;

  var YILDIZ_YOLU = 'M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.4l-5.8 3.1 1.1-6.5L2.6 9.4l6.5-.9z';
  var IKON = {
    yildiz: '<svg class="tsy-yildiz__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + YILDIZ_YOLU + '"/></svg>',
    onay: '<svg class="tsy-ikon tsy-ikon--onay" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.2 4.2L19 7"/></svg>',
    kapat: '<svg class="tsy-ikon" viewBox="0 0 64 64" aria-hidden="true" focusable="false"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>',
    tamam: '<svg class="tsy-ikon tsy-ikon--buyuk" viewBox="0 0 48 48" aria-hidden="true" focusable="false"><circle cx="24" cy="24" r="21"/><path d="M15 24.5l6.2 6.2L33.5 18"/></svg>',
    bilgi: '<svg class="tsy-ikon tsy-ikon--buyuk" viewBox="0 0 48 48" aria-hidden="true" focusable="false"><circle cx="24" cy="24" r="21"/><path d="M24 22v11M24 15.5v.5"/></svg>'
  };

  var METIN = {
    tr: {
      yerel: 'tr-TR',
      puanEtiket: '5 üzerinden {p}',
      degerlendirme: '{n} değerlendirme',
      yorumSayisi: '{n} yorum',
      yorumYaz: 'Yorum yaz',
      bosBaslik: 'Bu ürün için henüz yorum yok.',
      bosMetin: 'Ürünü satın aldıysanız ilk yorumu siz yazabilirsiniz.',
      puansiz: 'Henüz puan verilmedi',
      dogrulanmis: 'Doğrulanmış alıcı',
      satinAlinan: 'Satın alınan: {v}',
      musteri: 'Müşteri',
      sirala: 'Sırala',
      yeni: 'En yeni',
      yuksek: 'En yüksek puan',
      dusuk: 'En düşük puan',
      dahaFazla: 'Daha fazla yorum',
      yukleniyor: 'Yükleniyor',
      kapat: 'Kapat',
      formUst: 'Ürün yorumu',
      puanSoru: 'Ürünü nasıl buldunuz?',
      puanAd: ['Hiç beğenmedim', 'Beğenmedim', 'İdare eder', 'Beğendim', 'Çok beğendim'],
      yildizSec: '{n} yıldız',
      baslik: 'Başlık',
      istegeBagli: 'isteğe bağlı',
      yorum: 'Yorumunuz',
      yorumIpucu: 'Kalıbı, kumaşı ve bedeni nasıl buldunuz?',
      gonder: 'Yorumu gönder',
      gonderiliyor: 'Gönderiliyor',
      onayNotu: 'Yorumunuz incelendikten sonra yayımlanır.',
      puanSec: 'Lütfen bir puan seçin.',
      girisBaslik: 'Giriş yapın',
      girisMetin: 'Yorum yapmak için hesabınıza giriş yapın. Yalnızca bu ürünü satın alan müşterilerimiz yorum yapabilir.',
      girisDugme: 'Giriş yap',
      aliciDegilBaslik: 'Bu ürünü henüz satın almadınız',
      aliciDegilMetin: 'Yalnızca bu ürünü satın alan müşterilerimiz yorum yapabilir.',
      gonderimBaslik: 'Siparişiniz hazırlanıyor',
      gonderimMetin: 'Siparişiniz gönderildikten sonra bu ürün için yorum yapabilirsiniz.',
      beklemedeBaslik: 'Yorumunuz alındı',
      beklemedeMetin: 'İncelendikten sonra yayımlanacak. Teşekkür ederiz.',
      duzenle: 'Yorumu düzenle',
      yayindaBaslik: 'Yorumunuz yayında',
      yayindaMetin: 'Bu ürün için yorumunuz yayımlandı. Teşekkür ederiz.',
      redBaslik: 'Yorumunuz yayımlanmadı',
      redSebep: 'Sebep: {s}',
      yenidenYaz: 'Yeniden yaz',
      tamam: 'Tamam',
      hata: 'İşlem şu anda yapılamıyor. Lütfen biraz sonra tekrar deneyin.',
      hatalar: {},
      bekleyenUrunler: 'Yorum bekleyen ürünler',
      yorumlarim: 'Yazdığım yorumlar',
      hesapBos: 'Henüz yorum yapmadınız.',
      durum: { beklemede: 'Onay bekliyor', yayinda: 'Yayında', reddedildi: 'Yayımlanmadı' }
    },
    en: {
      yerel: 'en-GB',
      puanEtiket: '{p} out of 5',
      degerlendirme: '{n} ratings',
      yorumSayisi: '{n} reviews',
      yorumYaz: 'Write a review',
      bosBaslik: 'There are no reviews for this product yet.',
      bosMetin: 'If you have purchased it, you can write the first one.',
      puansiz: 'Not rated yet',
      dogrulanmis: 'Verified buyer',
      satinAlinan: 'Purchased: {v}',
      musteri: 'Customer',
      sirala: 'Sort',
      yeni: 'Newest',
      yuksek: 'Highest rated',
      dusuk: 'Lowest rated',
      dahaFazla: 'More reviews',
      yukleniyor: 'Loading',
      kapat: 'Close',
      formUst: 'Product review',
      puanSoru: 'How did you find the product?',
      puanAd: ['Did not like it at all', 'Did not like it', 'It was okay', 'Liked it', 'Loved it'],
      yildizSec: '{n} stars',
      baslik: 'Title',
      istegeBagli: 'optional',
      yorum: 'Your review',
      yorumIpucu: 'How were the fit, the fabric and the size?',
      gonder: 'Submit review',
      gonderiliyor: 'Sending',
      onayNotu: 'Your review is published after it has been checked.',
      puanSec: 'Please choose a rating.',
      girisBaslik: 'Sign in',
      girisMetin: 'Sign in to your account to write a review. Only customers who purchased this product can review it.',
      girisDugme: 'Sign in',
      aliciDegilBaslik: 'You have not purchased this product yet',
      aliciDegilMetin: 'Only customers who purchased this product can review it.',
      gonderimBaslik: 'Your order is being prepared',
      gonderimMetin: 'You can review this product once your order has been shipped.',
      beklemedeBaslik: 'We received your review',
      beklemedeMetin: 'It will be published after it has been checked. Thank you.',
      duzenle: 'Edit review',
      yayindaBaslik: 'Your review is live',
      yayindaMetin: 'Your review for this product has been published. Thank you.',
      redBaslik: 'Your review was not published',
      redSebep: 'Reason: {s}',
      yenidenYaz: 'Write again',
      tamam: 'Done',
      hata: 'This cannot be done right now. Please try again shortly.',
      hatalar: {
        giris: 'Please sign in to your account to write a review.',
        puan: 'Please choose a rating between 1 and 5.',
        alici: 'Only customers who purchased this product can review it.',
        gonderim: 'You can write a review once your order has been shipped.',
        urun: 'Product not found.',
        sinir: 'Too many requests. Please try again in a minute.'
      },
      bekleyenUrunler: 'Products waiting for your review',
      yorumlarim: 'Reviews I wrote',
      hesapBos: 'You have not written a review yet.',
      durum: { beklemede: 'Awaiting approval', yayinda: 'Published', reddedildi: 'Not published' }
    }
  };

  var SINIR = { baslik: 100, yorum: 2000 };
  var pencere = null;

  function el(etiket, sinif, metin) {
    var dugum = document.createElement(etiket);
    if (sinif) dugum.className = sinif;
    if (metin != null) dugum.textContent = metin;
    return dugum;
  }

  function doldur(sablon, degerler) {
    return String(sablon).replace(/\{(\w+)\}/g, function (tum, ad) {
      return degerler && degerler[ad] != null ? degerler[ad] : '';
    });
  }

  function tekrar(parca, adet) {
    var cikti = '';
    for (var i = 0; i < adet; i++) cikti += parca;
    return cikti;
  }

  function baglamOlustur(kok) {
    var veri = kok.dataset;
    var dil = veri.locale === 'en' ? 'en' : 'tr';
    return {
      kok: kok,
      govde: kok.querySelector('[data-tsy-govde]'),
      api: String(veri.api || '').replace(/\/+$/, ''),
      shop: veri.shop || '',
      dil: dil,
      m: METIN[dil],
      kokAdres: String(veri.root || '/').replace(/\/+$/, ''),
      girisAdres: veri.loginUrl || '/account/login',
      urunNo: veri.productId || '',
      urunAdi: veri.productTitle || '',
      urunAdres: veri.productUrl || location.pathname,
      musteriNo: veri.customerId || '',
      eposta: veri.customerEmail || '',
      sirala: 'yeni',
      sayfa: 1,
      sayfaSayisi: 1,
      yorumlar: [],
      ozet: null
    };
  }

  function sayi(b, deger, ondalik) {
    return Number(deger).toLocaleString(b.m.yerel, { minimumFractionDigits: ondalik || 0, maximumFractionDigits: ondalik || 0 });
  }

  function tarih(b, deger) {
    var gun = new Date(deger);
    if (isNaN(gun.getTime())) return '';
    return gun.toLocaleDateString(b.m.yerel, { day: 'numeric', month: 'long', year: 'numeric' });
  }

  function adres(b, yol, parametreler) {
    var sorgu = ['shop=' + encodeURIComponent(b.shop)];
    Object.keys(parametreler || {}).forEach(function (ad) {
      sorgu.push(encodeURIComponent(ad) + '=' + encodeURIComponent(parametreler[ad]));
    });
    return b.api + '/api/reviews/' + yol + '?' + sorgu.join('&');
  }

  function coz(yanit) {
    return yanit.json().then(function (veri) {
      veri.kod = yanit.status;
      return veri;
    });
  }

  function getir(b, yol, parametreler) {
    return fetch(adres(b, yol, parametreler), { headers: { Accept: 'application/json' } }).then(coz);
  }

  function yolla(b, yol, govde) {
    return fetch(adres(b, yol), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(govde)
    }).then(coz);
  }

  function jetonAnahtari(b) {
    return 'tsy:jeton:' + b.shop + ':' + b.musteriNo;
  }

  function jetonOku(b) {
    try {
      return localStorage.getItem(jetonAnahtari(b)) || '';
    } catch (hata) {
      return '';
    }
  }

  function jetonYaz(b, jeton) {
    try {
      if (jeton) localStorage.setItem(jetonAnahtari(b), jeton);
      else localStorage.removeItem(jetonAnahtari(b));
    } catch (hata) {
      return;
    }
  }

  function kimlik(b, ek) {
    var govde = { customer_id: b.musteriNo, email: b.eposta, token: jetonOku(b) };
    Object.keys(ek || {}).forEach(function (ad) { govde[ad] = ek[ad]; });
    return govde;
  }

  function hataMetni(b, veri) {
    if (veri && veri.error && b.m.hatalar[veri.error]) return b.m.hatalar[veri.error];
    if (veri && veri.message && b.dil === 'tr') return veri.message;
    return b.m.hata;
  }

  function urunAdresi(b, tutamac) {
    return b.kokAdres + '/products/' + tutamac;
  }

  function kucukGorsel(kaynak, genislik) {
    if (!kaynak) return '';
    return kaynak + (kaynak.indexOf('?') > -1 ? '&' : '?') + 'width=' + genislik;
  }

  function yildizlar(b, puan, ek) {
    var kap = el('span', 'tsy-yildiz' + (ek ? ' ' + ek : ''));
    kap.setAttribute('role', 'img');
    kap.setAttribute('aria-label', doldur(b.m.puanEtiket, { p: sayi(b, puan, puan % 1 ? 1 : 0) }));
    var bos = el('span', 'tsy-yildiz__bos');
    bos.innerHTML = tekrar(IKON.yildiz, 5);
    var dolu = el('span', 'tsy-yildiz__dolu');
    dolu.innerHTML = tekrar(IKON.yildiz, 5);
    dolu.style.width = Math.max(0, Math.min(100, (puan / 5) * 100)) + '%';
    kap.appendChild(bos);
    kap.appendChild(dolu);
    return kap;
  }

  function dugme(sinif, metin) {
    var d = el('button', sinif, metin);
    d.type = 'button';
    return d;
  }

  function ozetCiz(b) {
    var ozet = b.ozet;
    var kap = el('aside', 'tsy-ozet');
    if (ozet.count > 0) {
      kap.appendChild(el('div', 'tsy-ozet__puan', sayi(b, ozet.average, 1)));
      kap.appendChild(yildizlar(b, ozet.average, 'tsy-yildiz--orta'));
      kap.appendChild(el('div', 'tsy-ozet__adet', doldur(b.m.degerlendirme, { n: sayi(b, ozet.count) })));
      var dagilim = el('div', 'tsy-dagilim');
      for (var puan = 5; puan >= 1; puan--) {
        var adet = ozet.distribution[puan] || 0;
        var satir = el('div', 'tsy-dagilim__satir');
        satir.appendChild(el('span', 'tsy-dagilim__puan', String(puan)));
        var cubuk = el('span', 'tsy-dagilim__cubuk');
        var dolu = el('span', 'tsy-dagilim__dolu');
        dolu.style.width = (adet / ozet.count) * 100 + '%';
        cubuk.appendChild(dolu);
        satir.appendChild(cubuk);
        satir.appendChild(el('span', 'tsy-dagilim__adet', sayi(b, adet)));
        dagilim.appendChild(satir);
      }
      kap.appendChild(dagilim);
    } else {
      kap.appendChild(el('div', 'tsy-ozet__adet tsy-ozet__adet--tek', b.m.puansiz));
    }
    var yaz = dugme('btn tsy-ozet__dugme', b.m.yorumYaz);
    yaz.addEventListener('click', function () { yazAc(b, yaz); });
    kap.appendChild(yaz);
    return kap;
  }

  function yorumCiz(b, y) {
    var kart = el('article', 'tsy-yorum');
    var ust = el('div', 'tsy-yorum__ust');
    ust.appendChild(yildizlar(b, y.rating));
    ust.appendChild(el('time', 'tsy-yorum__tarih', tarih(b, y.date)));
    kart.appendChild(ust);
    if (y.title) kart.appendChild(el('h4', 'tsy-yorum__baslik', y.title));
    if (y.body) kart.appendChild(el('p', 'tsy-yorum__metin', y.body));
    var alt = el('div', 'tsy-yorum__alt');
    alt.appendChild(el('span', 'tsy-yorum__ad', y.name || b.m.musteri));
    if (y.verified) {
      var rozet = el('span', 'tsy-rozet');
      rozet.innerHTML = IKON.onay;
      rozet.appendChild(el('span', null, b.m.dogrulanmis));
      alt.appendChild(rozet);
    }
    if (y.variant && !/^default title$/i.test(y.variant)) {
      alt.appendChild(el('span', 'tsy-yorum__varyant', doldur(b.m.satinAlinan, { v: y.variant })));
    }
    kart.appendChild(alt);
    return kart;
  }

  function listeCiz(b) {
    var kap = el('div', 'tsy-liste');
    var ust = el('div', 'tsy-liste__ust');
    ust.appendChild(el('span', 'tsy-liste__adet', doldur(b.m.yorumSayisi, { n: sayi(b, b.ozet.total) })));
    if (b.ozet.total > 1) {
      var secim = el('select', 'tsy-liste__sirala');
      secim.setAttribute('aria-label', b.m.sirala);
      ['yeni', 'yuksek', 'dusuk'].forEach(function (ad) {
        var secenek = el('option', null, b.m[ad]);
        secenek.value = ad;
        if (ad === b.sirala) secenek.selected = true;
        secim.appendChild(secenek);
      });
      secim.addEventListener('change', function () {
        b.sirala = secim.value;
        b.sayfa = 1;
        yukle(b).then(function () {
          var yeniSecim = b.govde.querySelector('.tsy-liste__sirala');
          if (yeniSecim) yeniSecim.focus();
        });
      });
      ust.appendChild(secim);
    }
    kap.appendChild(ust);
    b.yorumlar.forEach(function (y) { kap.appendChild(yorumCiz(b, y)); });
    if (b.sayfa < b.sayfaSayisi) {
      var alt = el('div', 'tsy-liste__alt');
      var fazla = dugme('btn btn--secondary tsy-liste__fazla', b.m.dahaFazla);
      fazla.addEventListener('click', function () {
        fazla.disabled = true;
        fazla.textContent = b.m.yukleniyor;
        var onceki = b.yorumlar.length;
        b.sayfa += 1;
        yukle(b).then(function (tamam) {
          if (!tamam) b.sayfa -= 1;
          var kartlar = b.govde.querySelectorAll('.tsy-yorum');
          if (kartlar[onceki]) {
            kartlar[onceki].setAttribute('tabindex', '-1');
            kartlar[onceki].focus({ preventScroll: true });
          }
        });
      });
      alt.appendChild(fazla);
      kap.appendChild(alt);
    }
    return kap;
  }

  function bosCiz(b) {
    var kap = el('div', 'tsy-bos');
    kap.appendChild(el('p', 'tsy-bos__baslik', b.m.bosBaslik));
    kap.appendChild(el('p', 'tsy-bos__metin', b.m.bosMetin));
    var yaz = dugme('btn tsy-bos__dugme', b.m.yorumYaz);
    yaz.addEventListener('click', function () { yazAc(b, yaz); });
    kap.appendChild(yaz);
    return kap;
  }

  function ciz(b) {
    b.govde.textContent = '';
    if (!b.ozet.total) {
      b.govde.appendChild(bosCiz(b));
      return;
    }
    var duzen = el('div', 'tsy-duzen');
    duzen.appendChild(ozetCiz(b));
    duzen.appendChild(listeCiz(b));
    b.govde.appendChild(duzen);
  }

  function yukle(b) {
    return getir(b, 'list', { product_id: b.urunNo, sayfa: b.sayfa, sirala: b.sirala }).then(function (veri) {
      if (!veri || !veri.ok || veri.enabled === false) return false;
      b.ozet = veri.summary;
      b.sayfaSayisi = veri.pages || 1;
      b.yorumlar = b.sayfa === 1 ? veri.reviews : b.yorumlar.concat(veri.reviews);
      ciz(b);
      return true;
    }).catch(function () {
      return false;
    });
  }

  function baslikPuani(b) {
    var eski = document.querySelector('.tsy-baslik-puan');
    if (eski) eski.parentNode.removeChild(eski);
    if (!b.ozet || !b.ozet.count) return;
    var baslik = document.querySelector('.product-single__meta .product-single__title') || document.querySelector('.product-single__title');
    if (!baslik) return;
    var bag = el('a', 'tsy tsy-baslik-puan');
    bag.href = '#' + (b.kok.id || 'yorumlar');
    bag.appendChild(yildizlar(b, b.ozet.average));
    bag.appendChild(el('span', 'tsy-baslik-puan__deger', sayi(b, b.ozet.average, 1)));
    bag.appendChild(el('span', 'tsy-baslik-puan__adet', '(' + sayi(b, b.ozet.count) + ')'));
    bag.addEventListener('click', function (olay) {
      olay.preventDefault();
      b.kok.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    baslik.parentNode.insertBefore(bag, baslik.nextSibling);
  }

  function odaklanabilir(kap) {
    return Array.prototype.slice.call(kap.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled])'));
  }

  function pencereKapat() {
    if (!pencere) return;
    var eski = pencere;
    pencere = null;
    document.removeEventListener('keydown', eski.tus);
    document.documentElement.classList.remove('tsy-kilit');
    eski.ortu.classList.remove('is-acik');
    setTimeout(function () {
      if (eski.ortu.parentNode) eski.ortu.parentNode.removeChild(eski.ortu);
    }, 200);
    if (eski.tetik && document.body.contains(eski.tetik)) eski.tetik.focus({ preventScroll: true });
  }

  function pencereGoster(b, icerik, tetik) {
    if (pencere) {
      pencere.icerik.textContent = '';
      pencere.icerik.appendChild(icerik);
      pencere.kutu.scrollTop = 0;
      odakVer(pencere);
      return;
    }
    var ortu = el('div', 'tsy tsy-pencere');
    ortu.setAttribute('role', 'dialog');
    ortu.setAttribute('aria-modal', 'true');
    ortu.setAttribute('aria-label', b.m.formUst);
    var kutu = el('div', 'tsy-pencere__kutu');
    var kapat = dugme('tsy-pencere__kapat');
    kapat.setAttribute('aria-label', b.m.kapat);
    kapat.innerHTML = IKON.kapat;
    kapat.addEventListener('click', pencereKapat);
    var alan = el('div', 'tsy-pencere__icerik');
    alan.appendChild(icerik);
    kutu.appendChild(kapat);
    kutu.appendChild(alan);
    ortu.appendChild(kutu);
    ortu.addEventListener('mousedown', function (olay) {
      if (olay.target === ortu) pencereKapat();
    });
    var kayit = { ortu: ortu, kutu: kutu, icerik: alan, tetik: tetik || null, tus: null };
    kayit.tus = function (olay) {
      if (olay.key === 'Escape') {
        pencereKapat();
        return;
      }
      if (olay.key !== 'Tab') return;
      var liste = odaklanabilir(kutu);
      if (!liste.length) return;
      var ilk = liste[0];
      var son = liste[liste.length - 1];
      if (olay.shiftKey && document.activeElement === ilk) {
        olay.preventDefault();
        son.focus();
      } else if (!olay.shiftKey && document.activeElement === son) {
        olay.preventDefault();
        ilk.focus();
      }
    };
    document.addEventListener('keydown', kayit.tus);
    document.body.appendChild(ortu);
    document.documentElement.classList.add('tsy-kilit');
    pencere = kayit;
    requestAnimationFrame(function () {
      ortu.classList.add('is-acik');
      odakVer(kayit);
    });
  }

  function odakVer(kayit) {
    var hedef = kayit.icerik.querySelector('[data-tsy-odak]') || kayit.kutu.querySelector('.tsy-pencere__kapat');
    if (hedef) hedef.focus({ preventScroll: true });
  }

  function durumIcerigi(b, secenek) {
    var kap = el('div', 'tsy-durum');
    var ikon = el('div', 'tsy-durum__ikon');
    ikon.innerHTML = secenek.ikon === 'tamam' ? IKON.tamam : IKON.bilgi;
    kap.appendChild(ikon);
    kap.appendChild(el('h3', 'tsy-durum__baslik', secenek.baslik));
    if (secenek.metin) kap.appendChild(el('p', 'tsy-durum__metin', secenek.metin));
    if (secenek.alinti) {
      var alinti = el('div', 'tsy-durum__alinti');
      alinti.appendChild(yildizlar(b, secenek.alinti.rating));
      if (secenek.alinti.title) alinti.appendChild(el('p', 'tsy-durum__alinti-baslik', secenek.alinti.title));
      if (secenek.alinti.body) alinti.appendChild(el('p', 'tsy-durum__alinti-metin', secenek.alinti.body));
      kap.appendChild(alinti);
    }
    var dugmeler = el('div', 'tsy-durum__dugmeler');
    (secenek.dugmeler || []).forEach(function (tanim, sira) {
      var d;
      if (tanim.adres) {
        d = el('a', tanim.sinif, tanim.metin);
        d.href = tanim.adres;
      } else {
        d = dugme(tanim.sinif, tanim.metin);
        d.addEventListener('click', tanim.tikla);
      }
      if (sira === 0) d.setAttribute('data-tsy-odak', '');
      dugmeler.appendChild(d);
    });
    kap.appendChild(dugmeler);
    return kap;
  }

  function tamamDugmesi(b, sinif) {
    return { sinif: sinif || 'btn btn--full', metin: b.m.tamam, tikla: pencereKapat };
  }

  function yukleniyorIcerigi(b) {
    var kap = el('div', 'tsy-durum tsy-durum--yukleniyor');
    kap.appendChild(el('span', 'tsy-donen'));
    kap.appendChild(el('p', 'tsy-durum__metin', b.m.yukleniyor));
    return kap;
  }

  function girisIcerigi(b) {
    var donus = b.urunAdres + (b.urunAdres.indexOf('?') > -1 ? '&' : '?') + 'yorum=yaz';
    return durumIcerigi(b, {
      ikon: 'bilgi',
      baslik: b.m.girisBaslik,
      metin: b.m.girisMetin,
      dugmeler: [{ sinif: 'btn btn--full', metin: b.m.girisDugme, adres: b.girisAdres + '?return_url=' + encodeURIComponent(donus) }]
    });
  }

  function formIcerigi(b, onceki) {
    var secili = (onceki && onceki.rating) || 0;
    var form = el('form', 'tsy-form');
    form.noValidate = true;
    form.appendChild(el('p', 'tsy-form__ust', b.m.formUst));
    form.appendChild(el('h3', 'tsy-form__urun', b.urunAdi));

    form.appendChild(el('p', 'tsy-form__soru', b.m.puanSoru));
    var secici = el('div', 'tsy-secici');
    secici.setAttribute('role', 'group');
    secici.setAttribute('aria-label', b.m.puanSoru);
    var puanAdi = el('p', 'tsy-secici__ad');
    puanAdi.setAttribute('aria-live', 'polite');
    var yildizDugmeleri = [];

    function boya(seviye) {
      yildizDugmeleri.forEach(function (d, sira) {
        d.classList.toggle('is-dolu', sira < seviye);
      });
      puanAdi.textContent = seviye ? b.m.puanAd[seviye - 1] : '';
    }

    for (var i = 1; i <= 5; i++) {
      (function (deger) {
        var d = dugme('tsy-secici__dugme');
        d.innerHTML = IKON.yildiz;
        d.setAttribute('aria-label', doldur(b.m.yildizSec, { n: deger }));
        d.setAttribute('aria-pressed', 'false');
        if (deger === 1) d.setAttribute('data-tsy-odak', '');
        d.addEventListener('mouseenter', function () { boya(deger); });
        d.addEventListener('click', function () {
          secili = deger;
          yildizDugmeleri.forEach(function (x, sira) { x.setAttribute('aria-pressed', sira + 1 === deger ? 'true' : 'false'); });
          boya(secili);
          hata.hidden = true;
        });
        yildizDugmeleri.push(d);
        secici.appendChild(d);
      })(i);
    }
    secici.addEventListener('mouseleave', function () { boya(secili); });
    form.appendChild(secici);
    form.appendChild(puanAdi);

    var baslikAlan = el('div', 'tsy-form__alan');
    var baslikEtiket = el('label', null, b.m.baslik + ' ');
    baslikEtiket.setAttribute('for', 'tsy-baslik');
    baslikEtiket.appendChild(el('span', 'tsy-form__ek', '(' + b.m.istegeBagli + ')'));
    var baslik = el('input', 'input-full');
    baslik.type = 'text';
    baslik.id = 'tsy-baslik';
    baslik.maxLength = SINIR.baslik;
    baslik.value = (onceki && onceki.title) || '';
    baslikAlan.appendChild(baslikEtiket);
    baslikAlan.appendChild(baslik);
    form.appendChild(baslikAlan);

    var yorumAlan = el('div', 'tsy-form__alan');
    var yorumEtiket = el('label', null, b.m.yorum + ' ');
    yorumEtiket.setAttribute('for', 'tsy-yorum');
    yorumEtiket.appendChild(el('span', 'tsy-form__ek', '(' + b.m.istegeBagli + ')'));
    var yorum = el('textarea', 'input-full');
    yorum.id = 'tsy-yorum';
    yorum.rows = 5;
    yorum.maxLength = SINIR.yorum;
    yorum.placeholder = b.m.yorumIpucu;
    yorum.value = (onceki && onceki.body) || '';
    var sayac = el('div', 'tsy-form__sayac');
    function sayacYaz() {
      sayac.textContent = sayi(b, yorum.value.length) + ' / ' + sayi(b, SINIR.yorum);
    }
    yorum.addEventListener('input', sayacYaz);
    sayacYaz();
    yorumAlan.appendChild(yorumEtiket);
    yorumAlan.appendChild(yorum);
    yorumAlan.appendChild(sayac);
    form.appendChild(yorumAlan);

    var hata = el('p', 'tsy-form__hata');
    hata.setAttribute('role', 'alert');
    hata.hidden = true;
    form.appendChild(hata);

    var gonderDugmesi = el('button', 'btn btn--full', b.m.gonder);
    gonderDugmesi.type = 'submit';
    form.appendChild(gonderDugmesi);
    form.appendChild(el('p', 'tsy-form__not', b.m.onayNotu));

    function hataGoster(metin) {
      hata.textContent = metin;
      hata.hidden = false;
    }

    form.addEventListener('submit', function (olay) {
      olay.preventDefault();
      if (!secili) {
        hataGoster(b.m.puanSec);
        yildizDugmeleri[0].focus();
        return;
      }
      hata.hidden = true;
      gonderDugmesi.disabled = true;
      gonderDugmesi.textContent = b.m.gonderiliyor;
      var govde = kimlik(b, { product_id: b.urunNo, rating: secili, title: baslik.value, body: yorum.value, locale: b.dil });
      yolla(b, 'submit', govde).then(function (veri) {
        if (veri && veri.ok) {
          durumGoster(b, {
            state: veri.state || 'beklemede',
            review: { rating: secili, title: baslik.value.trim(), body: yorum.value.trim() }
          });
          return;
        }
        gonderDugmesi.disabled = false;
        gonderDugmesi.textContent = b.m.gonder;
        hataGoster(hataMetni(b, veri));
      }).catch(function () {
        gonderDugmesi.disabled = false;
        gonderDugmesi.textContent = b.m.gonder;
        hataGoster(b.m.hata);
      });
    });

    boya(secili);
    if (secili) yildizDugmeleri[secili - 1].setAttribute('aria-pressed', 'true');
    return form;
  }

  function durumGoster(b, veri) {
    var durum = veri.state;
    if (durum === 'yazabilir') {
      pencereGoster(b, formIcerigi(b, null));
    } else if (durum === 'beklemede') {
      pencereGoster(b, durumIcerigi(b, {
        ikon: 'tamam',
        baslik: b.m.beklemedeBaslik,
        metin: b.m.beklemedeMetin,
        alinti: veri.review,
        dugmeler: [
          tamamDugmesi(b),
          { sinif: 'btn btn--secondary btn--full', metin: b.m.duzenle, tikla: function () { pencereGoster(b, formIcerigi(b, veri.review)); } }
        ]
      }));
    } else if (durum === 'yayinda') {
      pencereGoster(b, durumIcerigi(b, { ikon: 'tamam', baslik: b.m.yayindaBaslik, metin: b.m.yayindaMetin, alinti: veri.review, dugmeler: [tamamDugmesi(b)] }));
    } else if (durum === 'reddedildi') {
      pencereGoster(b, durumIcerigi(b, {
        ikon: 'bilgi',
        baslik: b.m.redBaslik,
        metin: veri.reason ? doldur(b.m.redSebep, { s: veri.reason }) : '',
        dugmeler: [
          { sinif: 'btn btn--full', metin: b.m.yenidenYaz, tikla: function () { pencereGoster(b, formIcerigi(b, veri.review)); } },
          tamamDugmesi(b, 'btn btn--secondary btn--full')
        ]
      }));
    } else if (durum === 'gonderim_bekliyor') {
      pencereGoster(b, durumIcerigi(b, { ikon: 'bilgi', baslik: b.m.gonderimBaslik, metin: b.m.gonderimMetin, dugmeler: [tamamDugmesi(b)] }));
    } else if (durum === 'alici_degil') {
      pencereGoster(b, durumIcerigi(b, { ikon: 'bilgi', baslik: b.m.aliciDegilBaslik, metin: b.m.aliciDegilMetin, dugmeler: [tamamDugmesi(b)] }));
    } else {
      jetonYaz(b, '');
      pencereGoster(b, girisIcerigi(b));
    }
  }

  function yazAc(b, tetik) {
    if (!b.musteriNo) {
      pencereGoster(b, girisIcerigi(b), tetik);
      return;
    }
    pencereGoster(b, yukleniyorIcerigi(b), tetik);
    yolla(b, 'me', kimlik(b, { product_id: b.urunNo })).then(function (veri) {
      if (!pencere) return;
      if (!veri || !veri.ok || veri.enabled === false) {
        pencereGoster(b, durumIcerigi(b, { ikon: 'bilgi', baslik: b.m.hata, dugmeler: [tamamDugmesi(b)] }));
        return;
      }
      if (veri.token) jetonYaz(b, veri.token);
      durumGoster(b, veri);
    }).catch(function () {
      if (!pencere) return;
      pencereGoster(b, durumIcerigi(b, { ikon: 'bilgi', baslik: b.m.hata, dugmeler: [tamamDugmesi(b)] }));
    });
  }

  function yazIstegi() {
    var eslesme = /[?&]yorum=yaz(&|$)/.test(location.search);
    if (!eslesme) return false;
    try {
      var temiz = location.search.replace(/([?&])yorum=yaz(&|$)/, function (tum, on, son) { return son ? on : ''; });
      history.replaceState(null, '', location.pathname + temiz + location.hash);
    } catch (hata) {
      return true;
    }
    return true;
  }

  function urunBaslat(kok) {
    var b = baglamOlustur(kok);
    if (!b.govde || !b.api || !b.shop || !b.urunNo) return;
    yukle(b).then(function (tamam) {
      if (!tamam) return;
      kok.hidden = false;
      baslikPuani(b);
      if (yazIstegi()) {
        kok.scrollIntoView({ block: 'start' });
        yazAc(b, kok.querySelector('.tsy-ozet__dugme, .tsy-bos__dugme'));
      }
    });
  }

  function urunKarti(b, urun, altIcerik) {
    var kart = el('div', 'tsy-kart');
    var bag = el('a', 'tsy-kart__gorsel');
    bag.href = urunAdresi(b, urun.productHandle);
    bag.setAttribute('aria-hidden', 'true');
    bag.tabIndex = -1;
    if (urun.productImage) {
      var gorsel = el('img');
      gorsel.src = kucukGorsel(urun.productImage, 160);
      gorsel.alt = '';
      gorsel.loading = 'lazy';
      bag.appendChild(gorsel);
    }
    kart.appendChild(bag);
    var metin = el('div', 'tsy-kart__metin');
    var ad = el('a', 'tsy-kart__ad', urun.productTitle);
    ad.href = urunAdresi(b, urun.productHandle);
    metin.appendChild(ad);
    if (urun.variant && !/^default title$/i.test(urun.variant)) metin.appendChild(el('div', 'tsy-kart__varyant', urun.variant));
    altIcerik(metin);
    kart.appendChild(metin);
    return kart;
  }

  function hesapCiz(b, veri) {
    b.govde.textContent = '';
    var bekleyen = veri.pending || [];
    var yorumlar = veri.reviews || [];
    if (bekleyen.length) {
      b.govde.appendChild(el('h3', 'tsy-hesap__alt', b.m.bekleyenUrunler));
      var izgara = el('div', 'tsy-kartlar');
      bekleyen.forEach(function (urun) {
        izgara.appendChild(urunKarti(b, urun, function (metin) {
          var yaz = el('a', 'btn btn--secondary btn--small tsy-kart__dugme', b.m.yorumYaz);
          yaz.href = urunAdresi(b, urun.productHandle) + '?yorum=yaz';
          metin.appendChild(yaz);
        }));
      });
      b.govde.appendChild(izgara);
    }
    b.govde.appendChild(el('h3', 'tsy-hesap__alt', b.m.yorumlarim));
    if (!yorumlar.length) {
      b.govde.appendChild(el('p', 'tsy-hesap__bos', b.m.hesapBos));
      return;
    }
    var liste = el('div', 'tsy-hesap__liste');
    yorumlar.forEach(function (y) {
      var satir = urunKarti(b, y, function (metin) {
        var ust = el('div', 'tsy-kart__ust');
        ust.appendChild(yildizlar(b, y.rating));
        ust.appendChild(el('span', 'tsy-etiket tsy-etiket--' + y.state, b.m.durum[y.state] || ''));
        metin.appendChild(ust);
        if (y.title) metin.appendChild(el('p', 'tsy-yorum__baslik', y.title));
        if (y.body) metin.appendChild(el('p', 'tsy-yorum__metin', y.body));
        if (y.state === 'reddedildi' && y.reason) metin.appendChild(el('p', 'tsy-kart__sebep', doldur(b.m.redSebep, { s: y.reason })));
        var alt = el('div', 'tsy-kart__alt');
        alt.appendChild(el('time', 'tsy-yorum__tarih', tarih(b, y.date)));
        if (y.state === 'reddedildi' || y.state === 'beklemede') {
          var bag = el('a', 'tsy-kart__bag', y.state === 'reddedildi' ? b.m.yenidenYaz : b.m.duzenle);
          bag.href = urunAdresi(b, y.productHandle) + '?yorum=yaz';
          alt.appendChild(bag);
        }
        metin.appendChild(alt);
      });
      satir.classList.add('tsy-kart--yorum');
      liste.appendChild(satir);
    });
    b.govde.appendChild(liste);
  }

  function hesapBaslat(kok) {
    var b = baglamOlustur(kok);
    if (!b.govde || !b.api || !b.shop || !b.musteriNo) return;
    yolla(b, 'mine', kimlik(b)).then(function (veri) {
      if (!veri || !veri.ok || veri.enabled === false || veri.state !== 'uye') return;
      if (veri.token) jetonYaz(b, veri.token);
      hesapCiz(b, veri);
      kok.hidden = false;
    }).catch(function () {
      return null;
    });
  }

  function baslat() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tsy="urun"]'), urunBaslat);
    Array.prototype.forEach.call(document.querySelectorAll('[data-tsy="hesap"]'), hesapBaslat);
  }

  document.addEventListener('shopify:section:load', function (olay) {
    var kok = olay.target && olay.target.querySelector ? olay.target.querySelector('[data-tsy="urun"]') : null;
    if (kok) urunBaslat(kok);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();
